import { TableBody } from '@mui/material';
import React from 'react';

import RequestCertificateRowArtist from './components/RequestCertificateRowArtist';

const RequestCertificateTableBodyArtist = ({ listRequestCertificate, page, pageSize }) => {
  return (
    <TableBody>
      {(listRequestCertificate || []).map((certificate, index) => (
        <RequestCertificateRowArtist
          key={index}
          index={index}
          certificate={certificate}
          page={page}
          pageSize={pageSize}
        />
      ))}
    </TableBody>
  );
};

export default RequestCertificateTableBodyArtist;
